module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "sigilnotintoc1",
    attrs: {
      "id": "pgepubid00008"
    }
  }, [_vm._v("ILLUSTRATIONS")]), _vm._v(" "), _c('p', {
    staticClass: "calibre5"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/Section0001.htm#illus01"
    }
  }, [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("Colonel F.L. Morrison, C.B., D.S.O., V.D.")])]), _c('br', {
    staticClass: "calibre1"
  }), _vm._v(" "), _c('br', {
    staticClass: "calibre1"
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/Text/Section0005.htm#illus03"
    }
  }, [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("Officers of the Battalion, July 1914")])]), _c('br', {
    staticClass: "calibre1"
  }), _vm._v(" "), _c('br', {
    staticClass: "calibre1"
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/Text/Section0006.htm#illus04"
    }
  }, [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("Cape Helles, Gallipoli")])]), _c('br', {
    staticClass: "calibre1"
  }), _vm._v(" "), _c('br', {
    staticClass: "calibre1"
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/Text/Section0006.htm#illus05"
    }
  }, [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("Gully Ravine, Cape Helles")])]), _c('br', {
    staticClass: "calibre1"
  }), _vm._v(" "), _c('br', {
    staticClass: "calibre1"
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/Text/Section0010.htm#illus08"
    }
  }, [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("Suez Canal at Ballah")])]), _c('br', {
    staticClass: "calibre1"
  }), _vm._v(" "), _c('br', {
    staticClass: "calibre1"
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/Text/Section0011.htm#illus09"
    }
  }, [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("In a Redoubt, Mahamdiya")])]), _c('br', {
    staticClass: "calibre1"
  }), _vm._v(" "), _c('br', {
    staticClass: "calibre1"
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/Text/Section0011.htm#illus10"
    }
  }, [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("Water Camels, Mahamdiya")])]), _c('br', {
    staticClass: "calibre1"
  }), _vm._v(" "), _c('br', {
    staticClass: "calibre1"
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/Text/Section0011.htm#illus11"
    }
  }, [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("Sheikh's Tomb, Katia")])]), _c('br', {
    staticClass: "calibre1"
  }), _vm._v(" "), _c('br', {
    staticClass: "calibre1"
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/Text/Section0011.htm#illus12"
    }
  }, [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("Bivouacs, El Rabah")])]), _c('br', {
    staticClass: "calibre1"
  }), _vm._v(" "), _c('br', {
    staticClass: "calibre1"
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/Text/Section0012.htm#illus13"
    }
  }, [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("Camel Lines, El Arish")])]), _c('br', {
    staticClass: "calibre1"
  }), _vm._v(" "), _c('br', {
    staticClass: "calibre1"
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/Text/Section0012.htm#illus14"
    }
  }, [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("Baggage Camels on Shore near El Arish")])]), _c('br', {
    staticClass: "calibre1"
  }), _vm._v(" "), _c('br', {
    staticClass: "calibre1"
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/Text/Section0013.htm#illus15"
    }
  }, [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("Mouth of Wadi El Arish")])]), _c('br', {
    staticClass: "calibre1"
  }), _vm._v(" "), _c('br', {
    staticClass: "calibre1"
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/Text/Section0013.htm#illus16"
    }
  }, [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("Bedouin Sheikhs, Belah")])]), _c('br', {
    staticClass: "calibre1"
  }), _vm._v(" "), _c('br', {
    staticClass: "calibre1"
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/Text/Section0013.htm#illus17"
    }
  }, [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("Bedouins, Khan Yunis")])]), _c('br', {
    staticClass: "calibre1"
  }), _vm._v(" "), _c('br', {
    staticClass: "calibre1"
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/Text/Section0014.htm#illus18"
    }
  }, [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("Typical Small Nullah near Wadi Ghuzzee")])]), _c('br', {
    staticClass: "calibre1"
  }), _vm._v(" "), _c('br', {
    staticClass: "calibre1"
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/Text/Section0014.htm#illus19"
    }
  }, [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("Native Girls, Belah")])]), _c('br', {
    staticClass: "calibre1"
  }), _vm._v(" "), _c('br', {
    staticClass: "calibre1"
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/Text/Section0015.htm#illus20"
    }
  }, [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("Inside Yapton Post")])]), _c('br', {
    staticClass: "calibre1"
  }), _vm._v(" "), _c('br', {
    staticClass: "calibre1"
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/Text/Section0015.htm#illus21"
    }
  }, [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("Sheikh Abbas")])]), _c('br', {
    staticClass: "calibre1"
  }), _vm._v(" "), _c('br', {
    staticClass: "calibre1"
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/Text/Section0015.htm#illus22"
    }
  }, [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("Observation Post in front of Yapton Post")])]), _c('br', {
    staticClass: "calibre1"
  }), _vm._v(" "), _c('br', {
    staticClass: "calibre1"
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/Text/Section0016.htm#illus23"
    }
  }, [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("Sausage Ridge, Deir Sineid")])]), _c('br', {
    staticClass: "calibre1"
  }), _vm._v(" "), _c('br', {
    staticClass: "calibre1"
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/Text/Section0016.htm#illus25"
    }
  }, [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("Orange Sellers, Mejdel")])]), _c('br', {
    staticClass: "calibre1"
  }), _vm._v(" "), _c('br', {
    staticClass: "calibre1"
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/Text/Section0016.htm#illus26"
    }
  }, [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("Berfylia")])]), _c('br', {
    staticClass: "calibre1"
  }), _vm._v(" "), _c('br', {
    staticClass: "calibre1"
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/Text/Section0017.htm#illus28"
    }
  }, [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("Jaffa from the Shore")])]), _c('br', {
    staticClass: "calibre1"
  }), _vm._v(" "), _c('br', {
    staticClass: "calibre1"
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/Text/Section0018.htm#illus29"
    }
  }, [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("In Sarona")])]), _c('br', {
    staticClass: "calibre1"
  })]), _vm._v(" "), _c('h2', {
    staticClass: "sigilnotintoc1 sigil_not_in_toc",
    attrs: {
      "id": "pgepubid00009"
    }
  }, [_vm._v("MAPS")]), _vm._v(" "), _c('p', {
    staticClass: "calibre5"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/Section0008.htm#illus06"
    }
  }, [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("Gallipoli—Battle of 12th July, 1915")])]), _c('br', {
    staticClass: "calibre1"
  }), _vm._v(" "), _c('br', {
    staticClass: "calibre1"
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/Text/Section0009.htm#illus07"
    }
  }, [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("Sketch to Illustrate Position on Night of 19-20th"), _c('br', {
    staticClass: "calibre1"
  }), _vm._v("\n  December, 1915")])]), _c('br', {
    staticClass: "calibre1"
  }), _vm._v(" "), _c('br', {
    staticClass: "calibre1"
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/Text/Section0016.htm#illus24"
    }
  }, [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("Area of Operations 7-8th November, 1917")])]), _c('br', {
    staticClass: "calibre1"
  }), _vm._v(" "), _c('br', {
    staticClass: "calibre1"
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/Text/Section0016.htm#illus27"
    }
  }, [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("Sketch showing Route taken by the Battalion between"), _c('br', {
    staticClass: "calibre1"
  }), _vm._v("\n  Gaza and Jaffa, November-December, 1917")])]), _c('br', {
    staticClass: "calibre1"
  }), _vm._v(" "), _c('br', {
    staticClass: "calibre1"
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/Text/Section0019.htm#illus30"
    }
  }, [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("Area of Operations 24-27th August, 1918")])]), _c('br', {
    staticClass: "calibre1"
  }), _vm._v(" "), _c('br', {
    staticClass: "calibre1"
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/Text/Section0019.htm#illus31"
    }
  }, [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("Moeuvres, September, 1918")])]), _c('br', {
    staticClass: "calibre1"
  }), _vm._v(" "), _c('br', {
    staticClass: "calibre1"
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/Text/Section0023.htm#illus34a"
    }
  }, [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("Gallipoli and the Dardanelles, Bird's-Eye View")])]), _c('br', {
    staticClass: "calibre1"
  }), _vm._v(" "), _c('br', {
    staticClass: "calibre1"
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/Text/Section0023.htm#illus36a"
    }
  }, [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("Northern Portion of Sinai Peninsula")])]), _c('br', {
    staticClass: "calibre1"
  }), _vm._v(" "), _c('br', {
    staticClass: "calibre1"
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/Text/Section0023.htm#illus35a"
    }
  }, [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("Gaza")])]), _c('br', {
    staticClass: "calibre1"
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a5ff7c0e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/Section0004.vue
// module id = 66
// module chunks = 0